var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "px-2 py-4 text-black bg-white shadow-sm border-b-2" },
    [
      _c(
        "div",
        { staticClass: "container flex justify-between" },
        [
          _c(
            "router-link",
            {
              staticClass: "text-black hover:text-black",
              attrs: { to: "/", exact: "" }
            },
            [
              _c(
                "div",
                { staticClass: "float-left flex items-center" },
                [
                  _c("marketplace-logo", {
                    attrs: { marketplace: "TESTSITE", size: "38" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-col" }, [
                    _c(
                      "span",
                      { staticClass: "uppercase text-xl leading-none" },
                      [_vm._v("Messaging")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-gray-600 text-small" }, [
                      _vm._v("management console")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "hidden" }, [
                      _vm._v(_vm._s(_vm.version))
                    ])
                  ])
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center space-x-2" },
            [
              _vm.hasAnyAuthority("ROLE_USER")
                ? _c(
                    "mc-dropdown",
                    [
                      _c(
                        "span",
                        {
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.userLogin))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "text-left",
                          on: { click: _vm.openMarketplaceModal }
                        },
                        [
                          _c(
                            "mc-dropdown-item",
                            { attrs: { icon: "wrench" } },
                            [
                              _c("div", { staticClass: "mr-3" }, [
                                _c(
                                  "div",
                                  { staticClass: "text-gray-700 text-tiny" },
                                  [_vm._v("Tenant:")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "capitalize" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedMarketplace.toLowerCase()
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "text-gray-700 text-tiny" },
                                  [_vm._v("Environment:")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "capitalize" }, [
                                  _vm._v(_vm._s(_vm.environment.toLowerCase()))
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasAnyAuthority("ROLE_ADMIN")
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/user-management" } },
                            [
                              _c(
                                "mc-dropdown-item",
                                {
                                  attrs: { icon: "user-circle", hasArrow: "" }
                                },
                                [
                                  _vm._v(
                                    "\n                        Admin MMC users\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAnyAuthority("ROLE_SUPER_ADMIN")
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/jhi-metrics" } },
                            [
                              _c(
                                "mc-dropdown-item",
                                {
                                  attrs: {
                                    icon: "tachometer-alt",
                                    hasArrow: ""
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        Metrics\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAnyAuthority("ROLE_SUPER_ADMIN")
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/jhi-health" } },
                            [
                              _c(
                                "mc-dropdown-item",
                                { attrs: { icon: "heart", hasArrow: "" } },
                                [
                                  _vm._v(
                                    "\n                        Health\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAnyAuthority("ROLE_SUPER_ADMIN")
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/jhi-configuration" } },
                            [
                              _c(
                                "mc-dropdown-item",
                                { attrs: { icon: "list", hasArrow: "" } },
                                [
                                  _vm._v(
                                    "\n                        Configuration\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAnyAuthority("ROLE_SUPER_ADMIN")
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/audits" } },
                            [
                              _c(
                                "mc-dropdown-item",
                                { attrs: { icon: "bell", hasArrow: "" } },
                                [
                                  _vm._v(
                                    "\n                        Audits\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasAnyAuthority("ROLE_SUPER_ADMIN")
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/logs" } },
                            [
                              _c(
                                "mc-dropdown-item",
                                { attrs: { icon: "tasks", hasArrow: "" } },
                                [
                                  _vm._v(
                                    "\n                        Logs\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.swaggerEnabled
                        ? _c(
                            "router-link",
                            { attrs: { to: "/admin/docs" } },
                            [
                              _c(
                                "mc-dropdown-item",
                                { attrs: { icon: "book", hasArrow: "" } },
                                [
                                  _vm._v(
                                    "\n                        API swagger\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inProduction
                        ? _c(
                            "a",
                            { attrs: { href: "./h2-console", target: "_tab" } },
                            [
                              _c(
                                "mc-dropdown-item",
                                { attrs: { icon: "hdd", hasArrow: "" } },
                                [
                                  _vm._v(
                                    "\n                        Database\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        { staticClass: "text-left", on: { click: _vm.logout } },
                        [
                          _c(
                            "mc-dropdown-item",
                            { attrs: { icon: "sign-out-alt", hasArrow: "" } },
                            [
                              _vm._v(
                                "\n                        Logout\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "mc-modal",
        {
          ref: "changeMarketplace",
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [_vm._v("Select a tenant")]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info mr-4",
                      on: { click: _vm.closeMarketplaceModal }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit", form: "select-marketplace" }
                    },
                    [_vm._v("Update settings")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c("div", [
            _c("p", [
              _vm._v("To change environment, use the correct okta app")
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: { id: "select-marketplace" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.selectMarketplace($event)
                  }
                }
              },
              [
                _c("fieldset", [
                  _c("legend", { staticClass: "mb-1" }, [_vm._v("Tenant")]),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "marketplaceSelect" }
                    },
                    [_vm._v("Select a tenant")]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newSelectedMarketplace,
                          expression: "newSelectedMarketplace"
                        }
                      ],
                      staticClass: "w-full",
                      attrs: { id: "marketplaceSelect" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.newSelectedMarketplace = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.userMarketplaces, function(marketplace) {
                      return _c(
                        "option",
                        { key: marketplace, domProps: { value: marketplace } },
                        [_vm._v(_vm._s(marketplace.toLowerCase()))]
                      )
                    }),
                    0
                  )
                ])
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }